<template>
  <b-container fluid>
    <b-alert :show="alert.show" :variant="alert.variant" class="mt-2" fade>
      {{alert.message}}
    </b-alert>
    <center><h1>Current Tariff Codes</h1></center>
    <b-row class="justify-content-md-center">
      <b-col class="my-1" cols=4>
          <b-input-group>
            <b-form-input v-model="input" placeholder="Type to Search" @keypress.enter="setFilter" />
            <b-input-group-append>
              <b-button variant="primary" @click="setFilter">Search</b-button>
              <b-button variant="warning" :disabled="!input" @click="input = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
      </b-col>
      <b-col class="my-1" cols=1>
        <b-btn variant=primary @click="getData" class="mb-0">
          Reload
        </b-btn>
      </b-col>
      <b-col class="my-1" cols=1>
        <b-btn variant=info @click="exportData" class="mb-0">
          Export CSV
        </b-btn>
      </b-col>
      <b-col class="my-1" cols=3>
        <b-pagination
          align="right"
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="mb-0"
        />
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
      <b-col class="my-1" cols=8>
        <b-table :busy="busy"
          :items="items" :fields="fields"
          :per-page="perPage" :current-page="currentPage"
          :filter="filter" @filtered="onFilter"
        >
          <template slot="table-busy">
            <center>
              <fingerprint-spinner :animation-duration="1500" :size="300" color="#293a93" class="align-middle" />
            </center>
          </template>
          <template slot="harmonizedcode" slot-scope="row">
            <b-form-input v-if="row.detailsShowing" v-model="row.item.tempcode" />
            <div v-else>{{row.item.harmonizedcode}}</div>
          </template>
          <template slot="eccn" slot-scope="row">
            <b-form-input v-if="row.detailsShowing" v-model="row.item.tempeccn" />
            <div v-else>{{row.item.eccn}}</div>
          </template>
          <template slot="countryoforigin" slot-scope="row">
            <b-form-select v-if="row.detailsShowing" v-model="row.item.tempcountry" :options="Object.keys(countries)" />
            <div v-else>{{row.item.countryoforigin}}</div>
          </template>
          <template slot="actions" slot-scope="row">
            <b-row>
              <b-col>
                <div v-if="row.detailsShowing">
                  <b-btn @click="row.toggleDetails">
                    Undo
                  </b-btn>
                  <b-btn variant="success" @click="onSubmitRow(row)">
                    Save
                  </b-btn>
                </div>
                <div v-else>
                  <b-btn @click="onClickEdit(row)">
                    Edit
                  </b-btn>
                </div>
              </b-col>
            </b-row>
          </template>
          <template slot="row-details" slot-scope="row" />
        </b-table>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
      <b-col cols=3 class="pt-2">
        <center><h3>Add new Tariff Code</h3></center>
        <b-form @submit="onSubmitForm">
          <b-form-row>
            <b-col cols=4>Product Number:</b-col>
            <b-col><b-form-input v-model="form.num" required /></b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols=4>Tariff Code:</b-col>
            <b-col><b-form-input v-model="form.code" required /></b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols=4>ECCN:</b-col>
            <b-col><b-form-input v-model="form.eccn" required /></b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols=4>Country:</b-col>
            <b-col><b-form-select v-if="countries" :options="Object.keys(countries)" v-model="form.country" required /></b-col>
          </b-form-row>
          <center>
            <b-btn class="mt-2" variant="primary" type="submit">
              Add Tariff Code
            </b-btn>
          </center>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import { FingerprintSpinner } from 'epic-spinners';
const BASE_API = `${process.env.VUE_API_ROOT}/ams3-fishioninfo/tariff-codes`;

export default {
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      fields: [
        { key: 'product_num', label: 'Product Number' },
        { key: 'description' },
        { key: 'harmonizedcode', label: 'Harmonized Tariff Code' },
        { key: 'eccn', label: 'ECCN' },
        { key: 'countryoforigin', label: 'Country of Origin' },
        'actions'
      ],
      items: [],
      filteredItems: [],
      busy: true,
      input: '',
      filter: '',
      form: { },
      alert: { show: false, message: '', variant: 'info' },
    };
  },
  components: {
    FingerprintSpinner
  },
  mounted() {
    this.getCountries();
    this.getData();
  },
  computed: {
    ...mapGetters({
      countries: 'countries',
    }),
  },
  methods: {
    ...mapActions({
      getCountries: 'getCountries',
    }),
    getData() {
      this.busy = true;
      axios.get(`${BASE_API}/`).then(response => {
        this.items = response.data;
        this.filteredItems = this.items;
        this.totalRows = this.items.length;
        this.busy = false;
      });
    },
    setFilter(evt) {
      if (!!evt) evt.preventDefault()
      this.busy = true;
      this.filter = this.input;
    },
    onFilter(items) {
      this.totalRows = items.length;
      this.filteredItems = items;
      this.busy = false;
    },
    onClickEdit(row) {
      let p = this.page;
      row.item.tempcode = row.item.harmonizedcode;
      row.item.tempcountry = row.item.countryoforigin;
      row.item.tempeccn = row.item.eccn;
      row.toggleDetails();
      this.page = p;
    },
    onDelete(row) {
      this.alert = { message: 'Request Sent', variant: 'info', show: true };
      axios({
        method: 'delete',
        url: `${BASE_API}/${row.item.product_id}`,
        data: { code: row.item.harmonizedcode, eccn: rot.item.eccn, country: row.item.countryoforigin },
      }).then(response => {
        this.alert = { message: 'Tariff Code Deleted.', variant: 'success', show: 3 };
        this.getData();
      }).catch((error) => {
        console.error(error);
        if (error.response) {
          this.alert = { message: error.response.data, variant: 'danger', show: 3 };
        } else {
          this.alert = { message: 'Failed to Delete Code', variant: 'danger', show: 3 };
        }
      })
    },
    onSubmitRow(row) {
      this.alert = { message: 'Request Sent', variant: 'info', show: true };
      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/${row.item.product_id}`,
        data: {
          code: row.item.tempcode,
          eccn: row.item.tempeccn,
          country: row.item.tempcountry,
          old_code: row.item.harmonizedcode,
          old_country: row.item.countryoforigin,
          old_eccn: row.item.eccn,
        },
      }).then(response => {
        this.alert = { message: 'Tariff Code Updated.', variant: 'success', show: 3 };
        this.getData();
      }).catch((error) => {
        console.error(error);
        if (error.response) {
          this.alert = { message: error.response.data, variant: 'danger', show: 3 };
        } else {
          this.alert = { message: 'Failed to Update Code', variant: 'danger', show: 3 };
        }
      })
    },
    onSubmitForm(event) {
      event.preventDefault();
      this.alert = { message: 'Request Sent', variant: 'info', show: true };

      if (this.items.filter( e => e && (e.product_num == this.form.num) ).length == 0) {
        axios({
          method: 'post',
          headers: { 'Content-Type': 'text/plain' },
          url: `${BASE_API}/`,
          data: this.form,
        }).then(response => {
          this.alert = { message: 'Tariff Code Added.', variant: 'success', show: 3 };
          this.getData();
        }).catch((error) => {
          console.error(error);
          if (error.response) {
            this.alert = { message: error.response.data, variant: 'danger', show: 3 };
          } else {
            this.alert = { message: 'Failed to Add Code', variant: 'danger', show: 3 };
          }
        })
      } else {
        console.log(this.items.filter( e => e && (e.product_num == this.form.num) ));
        this.alert = { message: "That product already has a tariff code defined.", variant: 'danger', show: 3 };
        this.filter = this.form.num;
      }
    },
    exportData() {
        var csv = [[
          "Product Number",
          "Product Description",
          "Harmonized Tariff Code",
          "ECCN",
          "Country of Origin",
        ].join(',')]
        this.filteredItems.forEach(item => {
          if (item !== null) {
            csv.push([
              item.product_num,
              `"${item.description.replace(/(\r\n|\n|\r|\s+|\t|&nbsp;)/gm,' ').replace('"', '""').replace(/ +(?= )/g,'')}"`,
              item.harmonizedcode,
              item.eccn,
              item.countryoforigin,
            ].join(','))
          }
        })
        var csvString = csv.join('\n');

        var filename = 'export_tariffcode_' + new Date().toLocaleDateString() + '.csv';
        var link = document.createElement('a');
        link.style.display = 'none';
        link.setAttribute('target', '_blank');
        link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvString));
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ops-info/TariffCodes.vue